export default function resizeSlotIFrame(slotId, width, height) {
  const slot = (typeof slotId === 'string') ? window.document.getElementById(slotId) : slotId;
  const iframe = slot.tagName === 'IFRAME' ? slot : slot.querySelector('iframe');
  if (iframe) {
    if (width) iframe.width = width;
    if (height) iframe.height = height;
  }
  return iframe || false;
}
